import { useState } from 'react'
import BasicLayout from '@/components/Onboarding/Layout/BasicLayout'
import SelectList from '@/components/ui/selectlist'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

const SignUp = () => {
  const navigate = useNavigate()

  const [decision, setDecision] = useState(null)

  const navigateToNextPage = () => {
    if (decision === 'educator') {
      navigate('/educator_sign_up')
    } else {
      navigate('/join_short_code')
    }
  }

  return (
    <BasicLayout>
      <h1 className='text-2xl font-extrabold tracking-tight my-1'>
        Let's get started! Are you an educator or a student?
      </h1>

      <SelectList
        title="Are you an educator or a student?"
        value={decision}
        onChange={setDecision}
        options={[
          {
            emoji: '👩‍🏫',
            label: 'Educator',
            value: 'educator'
          },
          {
            emoji: '👩‍🎓',
            label: 'Student',
            value: 'student'
          }
        ]}
      />

      <Button onClick={navigateToNextPage} disabled={!decision}className='mt-2'>
        Continue
      </Button>
    </BasicLayout>
  )
}

export default SignUp
